<div class="dialog-container" [ngClass]="{ 'fullscreen-dialog': step === 3 }">

  <!-- STEP 1: Select Main Topic -->
  @if (step === 1) {
    <div class="step step-1">
      <div class="step1-container">
        
        <!-- LEFT SIDE CONTENT -->
        <div class="left-content">
          <h3>Have a question or need support?</h3>
          <p>
            To schedule a 1-on-1 appointment with a Solutions Consultant trained to meet your needs,
            let us know what you need help with today.
          </p>
        </div>

        <!-- DIVIDER -->
        <mat-divider vertical></mat-divider>

        <!-- RIGHT SIDE CONTENT -->
        <div class="right-content">
          <p>Please select from one of the topics below:*</p>

          @for (topic of topics; track $index) {
            <label class="container">
              {{ topic.title }}

              <input 
                type="radio" 
                name="customRadio" 
                [value]="topic.title"
                [(ngModel)]="selectedTopic"
              />

              <span class="checkmark"></span>
            </label>
          }

          <button 
            mat-raised-button 
            color="primary" 
            (click)="submitTopic()" 
            >
            Submit
          </button>

          @if (errorMsg) {
            <p class="error">{{ errorMsg }}</p>
          }
        </div>
      </div>
    </div>
  }

  <!-- STEP 2: Select Subtopic -->
  @if (step === 2) {
    <div class="step step-2">

      <p>Which {{ selectedTopic }} topic would you like to discuss?*</p>

      @for (sub of getSubtopicsForselectedTopic(); track $index) {
        <label class="container">
          {{ sub.name }}

          <input 
            type="radio" 
            name="customRadio" 
            [value]="sub"
            [(ngModel)]="selectedSubtopic"
          />

          <span class="checkmark"></span>
        </label>
      }

      <button 
        mat-raised-button 
        color="primary" 
        (click)="submitSubtopic()" 
        >
          Submit
      </button>

      @if (errorMsg) {
        <p class="error">{{ errorMsg }}</p>
      }

    </div>
  }

  <!-- STEP 3: Iframe -->
  @if (step === 3) {
    <div class="step step-3">

      @if (selectedSubtopic?.scheduling_url) {
        <iframe
          title="Scheduling iframe"
          [src]="getCalendlyUrl() | safeUrl"
          width="100%"
          height="100%"
          allowfullscreen>
        </iframe>
      }

    </div>
  }

</div>
